
import { NoticeBar, Carousel } from 'antd-mobile';

import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './AnnounceCustomComponent.less';

export default function AnnounceCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;   // 组件数据
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const customFeature = data.customFeature;
  styleObj['height'] = transformPx2Rem(customFeature.height,320);
  styleObj['width'] = transformPx2Rem(customFeature.width,320);
  // 图标类型
  const iconType = customFeature.selectImg.indexOf('announce') !== -1 ? `icon-${customFeature.selectImg}` : '';
  let iconStyle = {
    color: customFeature.lineBackgroundColor,
    backgroundImage: iconType === '' ? `url(${customFeature.selectImg})` : '',
  }
  /**
   * 组件内容处理
   */   
  let content = data.content;

  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component announce" style={styleObj}>
      {/* 横向滚动版 */}
      {customFeature.mode === 0 &&
        <NoticeBar 
          marqueeProps={{ loop: true, fps: 10/customFeature.interval*20, leading: 500,  trailing: 500}} 
          icon={<span className={`${iconType} announce-icon`} style={iconStyle}></span>}
        >
          {content.map((contentData, contentIndex) => 
            <span className="announce-text" key={contentIndex} onClick={() => customEvent({customFeature: contentData.customFeature})}>{contentData.secContent}</span>
          )}
        </NoticeBar>
      }
      {/* 纵向滚动版 */}
      {customFeature.mode === 1 &&
        <div className="announce-vertical">
          <span className={`${iconType} announce-icon`} style={iconStyle} ></span>
          <Carousel
            vertical
            dots={false}
            dragging={false}
            swiping={false}
            autoplay
            infinite
            autoplayInterval={`${Number(customFeature.interval) * 1000}`}
          >
            {content.map((contentData, contentIndex) => 
              <span className="announce-text" key={contentIndex} onClick={() => customEvent({customFeature: contentData.customFeature})}>{contentData.secContent}</span>
            )}
          </Carousel>
        </div>
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/announce-custom-component/AnnounceCustomComponent.jsx